







import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { CardMenuItem } from '../interfaces/card-menu.interface';
import BbParserService from '@/services/bb-parser.service';

//@ts-ignore
@Component
export default class Editor extends Vue {

  private text: string = '';

  constructor(private bbParserService = BbParserService) {
    super();
  }

  @Prop() private value: string;

  get preview() {
    return this.bbParserService.fromBb(this.value);
  }

  @Watch('value')
  private valueWatch() {
    this.text = this.value;
  }

  @Watch('text')
  private textWatch() {
    this.$emit('input', this.text);
  }

  mounted() {
    this.text = this.value;
  }
}
